import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const ClockIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 32 32',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path d="M 13 3 L 13 5 L 19 5 L 19 3 Z M 24.71875 5.28125 L 23.28125 6.71875 L 24.0625 7.5 L 23.03125 8.5625 C 21.125 6.972656 18.667969 6 16 6 C 9.9375 6 5 10.9375 5 17 C 5 23.0625 9.9375 28 16 28 C 22.0625 28 27 23.0625 27 17 C 27 14.332031 26.027344 11.875 24.4375 9.96875 L 25.5 8.9375 L 26.28125 9.71875 L 27.71875 8.28125 Z M 16 8 C 20.980469 8 25 12.019531 25 17 C 25 21.980469 20.980469 26 16 26 C 11.019531 26 7 21.980469 7 17 C 7 12.019531 11.019531 8 16 8 Z M 11.71875 11.28125 L 10.28125 12.71875 L 14.0625 16.5 C 14.019531 16.660156 14 16.828125 14 17 C 14 18.105469 14.894531 19 16 19 C 17.105469 19 18 18.105469 18 17 C 18 15.894531 17.105469 15 16 15 C 15.828125 15 15.660156 15.019531 15.5 15.0625 Z"></path>
  </SvgIcon>
);

export default ClockIcon;
